import React from 'react';
import { Shield, Globe, CreditCard, Lock, Check } from 'lucide-react';

const ICONS = { Shield, Globe, CreditCard, Lock, Check };

export const DEFAULT_TRUST_FACTS = [
  { icon: 'Globe', label: 'Für DE, AT & CH gebaut' },
  { icon: 'Shield', label: 'DSGVO-konform, EU-Hosting' },
  { icon: 'CreditCard', label: 'Kostenlos starten – ohne Kreditkarte' },
];

export function TrustStrip({ facts = DEFAULT_TRUST_FACTS, dark = false }) {
  return (
    <ul data-testid="trust-strip" className={`flex flex-wrap gap-x-6 gap-y-2 text-sm ${dark ? 'text-emerald-100/90' : 'text-gray-600'}`}>
      {facts.map((f, i) => {
        const Icon = ICONS[f.icon] || Check;
        return (
          <li key={i} className="inline-flex items-center gap-2">
            <Icon className={`h-4 w-4 ${dark ? 'text-emerald-300' : 'text-emerald-600'}`} aria-hidden="true" />
            <span>{f.label}</span>
          </li>
        );
      })}
    </ul>
  );
}

export default TrustStrip;
